import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=c3ccd91c&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=ts&"
export * from "./Error404.vue?vue&type=script&lang=ts&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=c3ccd91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ccd91c",
  null
  
)

export default component.exports